export const MOBILE_DEVICE = '(max-width: 1100px)';
export const DESKTOP_DEVICE = '(min-width: 1100px)';
